import React, { useState } from 'react';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import * as Types from 'pages/Pages/typings';
import makeStyles from '@material-ui/core/styles/makeStyles';

import DeletePageModal from 'pages/PageTypes/tabs/DeletePageModal';
import CreatePageModal from 'pages/PageTypes/components/CreatePageModal';
import NoPagesView from 'pages/PageTypes/components/NoPagesView';
import PagesTable from '../PagesTable';
import PagesCards from '../PagesCards';

interface Props {
  hasQuery: boolean;
  entityType: Types.EntityType;
  migrationInProgress?: boolean;
  pagesData: Types.EntitySearchResult;
  onDeleteEntity: (entityId: string) => void;
  onReload: () => void;
}

function PagesTab({
  hasQuery,
  entityType,
  migrationInProgress,
  pagesData,
  onDeleteEntity,
  onReload,
}: Props) {
  const classes = useStyles();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const isIndependentPage = _isNil(_get(entityType, 'personClientFieldId', null));
  const canAddOrDeletePages = !_get(entityType, '_isSyncManaged', false);
  const deleteModalSubtitle = isIndependentPage
    ? 'Deleting this page will remove it from search result and remove all content on it. Type in page name to delete it.'
    : 'Deleting this page will remove it from profiles of users and remove all content on it. Type in page name to delete it.';
  const [selectEntity, setSelectEntity] = useState<Types.Entity | null>(null);
  const pages: Types.Entity[] = _get(pagesData, 'results', []);

  const handleDeletePage = () => {
    const entityId = _get(selectEntity, 'id');
    entityId && onDeleteEntity(entityId);
  };

  const handleClickDelete = () => {
    setIsDeleteModalOpen(true);
  };

  return (
    <>
      {!!pages.length || hasQuery ? (
        <div className={classes.tableContainer}>
          <PagesCards pagesData={pagesData} />
          <PagesTable
            isIndependentPage={isIndependentPage}
            pagesData={pagesData}
            canAddOrDeletePages={canAddOrDeletePages}
            onDelete={handleClickDelete}
            onSelectEntity={setSelectEntity}
            onSetCreateModalOpen={setIsCreateModalOpen}
          />
        </div>
      ) : (
        <NoPagesView
          migrationInProgress={migrationInProgress}
          shouldRenderButton={canAddOrDeletePages}
          onClick={() => (migrationInProgress ? onReload() : setIsCreateModalOpen(true))}
        />
      )}
      <CreatePageModal open={isCreateModalOpen} onSetOpen={setIsCreateModalOpen} />
      <DeletePageModal
        name={_get(selectEntity, 'name', '')}
        open={isDeleteModalOpen}
        subtitle={deleteModalSubtitle}
        onSetOpen={setIsDeleteModalOpen}
        onDelete={handleDeletePage}
      />
    </>
  );
}

const useStyles = makeStyles((theme: any) => ({
  root: {},
  tableContainer: {
    marginBottom: theme.spacing(5),
  },
}));

export default PagesTab;
